module.exports = __webpack_public_path__ + "img/calendar-icon.0f365af3.svg";